import axios, { AxiosResponse } from "axios";
import { CrosswordResponse } from "@/models/Cms";
import { Auth } from "aws-amplify";
import { APP_CONFIGS } from "@/main";
import config from '../../configs/configs.json';
import { FrameControl } from "@/models/FrameControl";
import { CrosswordRaceResponse, CrosswordReplay, Crossword, CrosswordRaceResponseList, CrosswordRaceSolve } from "@/models/Crossword";

export const CONFIGS: FrameControl = config;
export const PUBLIC_HOST = CONFIGS.api.publicHost;
export const PRIVATE_HOST = CONFIGS.api.privateHost;

async function getAccessToken(): Promise<string> {
  return (await Auth.currentSession()).getAccessToken().getJwtToken();
}

export async function getCrosswords(page: number): Promise<AxiosResponse<CrosswordResponse>> {
  return axios.get<CrosswordResponse>(APP_CONFIGS.cms.endpoints.crosswords || 'undefined', {
    params: {
      "populate": "deep",
      "pagination[page]": page,
      "pagination[pageSize]": 5
    }
  });
}

export async function getCrosswordByTitle(title: string): Promise<AxiosResponse<CrosswordResponse>> {
  return axios.get<CrosswordResponse>(APP_CONFIGS.cms.endpoints.crosswords || 'undefined', {
    params: {
      "populate": "deep",
      "filters[title][$eq]": title
    }
  });
}

export async function getCrosswordPuzzle(puzzleId: string): Promise<AxiosResponse<CrosswordRaceResponse>> {
  return axios.get<CrosswordRaceResponse>(PUBLIC_HOST + `/puzzle/${puzzleId}`,
    {
      headers: {
        Authorization: await getAccessToken().catch(() => "")
      }
    }
  );
}

export async function publishCrosswordPuzzle(puzzle: Crossword): Promise<AxiosResponse<void>> {
  return axios.post<void>(PRIVATE_HOST + `/puzzle`,
    puzzle,
    {
      headers: {
        Authorization: await getAccessToken()
      }
    }
  );
}

export async function deletePuzzle(puzzleId: string): Promise<AxiosResponse<void>> {
  return axios.delete<void>(PRIVATE_HOST + `/puzzle/${puzzleId}`,
    {
      headers: {
        Authorization: await getAccessToken()
      }
    }
  );
}

export async function likePuzzle(puzzleId: string): Promise<AxiosResponse<void>> {
  return axios.post<void>(PRIVATE_HOST + `/puzzle/${puzzleId}/like`,
    null,
    {
      headers: {
        Authorization: await getAccessToken()
      }
    }
  );
}

export async function postGame(solve: CrosswordRaceSolve): Promise<AxiosResponse<void>> {
  return axios.post<void>(PRIVATE_HOST + `/game`,
    solve,
    {
      headers: {
        Authorization: await getAccessToken()
      }
    }
  );
}

export async function listPuzzles(sort: string, offset: number): Promise<AxiosResponse<CrosswordRaceResponseList>> {
  const postList = (await axios.get<CrosswordRaceResponseList>(PUBLIC_HOST + "/puzzle", {
    headers: {
      Authorization: await getAccessToken().catch(() => "")
    },
    params: {
      "sort": sort,
      "offset": offset,
    }
  }))
  return postList;
}

export async function getCrosswordReplay(gameId: string): Promise<AxiosResponse<CrosswordReplay>> {
  return axios.get<CrosswordReplay>(PUBLIC_HOST + `/game/${gameId}`);
}

export function emitCrosswordKeyEvent(key: string): void {
  const event = new CustomEvent('xframe:crosswordKeyboardEvent', {
    cancelable: true,
    detail: { key },
  });
  window.dispatchEvent(event);
}
